import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function translateLoaderFactory() {
  return new TranslateHttpLoader();
}
